import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);







  const features = [
    {
      title: "Feature 1",
      desc: "We provide in-depth consultation to understand your needs."
    },
    {
      title: "Feature 2",
      desc: "Our custom solutions are tailored to each unique requirement."
    },
    {
      title: "Feature 3",
      desc: "We ensure proactive communication throughout the process."
    },
    {
      title: "Feature 4",
      desc: "Our team brings years of industry experience to every project."
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "phone") {
      const cleaned = value.replace(/\D/g, ""); // remove non-digits
      if (cleaned.length <= 10) {
        setFormData((prev) => ({ ...prev, [name]: cleaned }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, message } = formData;
  
    if (!name || !email || !phone || !message) {
      toast.warn("Please fill in all fields!");
      return;
    }
  
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.warn("Please enter a valid email address.");
      return;
    }
  
    // Phone validation: exactly 10 digits
    const cleanedPhone = phone.replace(/\D/g, "");
    if (cleanedPhone.length !== 10) {
      toast.warn("Phone number must be exactly 10 digits.");
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await fetch("https://100billionrealestate.com/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
        toast.success("Message sent successfully!");
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };
  
  
  return (
    <>
      <div className="other-pages-main-section-v9">
        <motion.h2
          className="enquiry-heading"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Get in Touch with Us
        </motion.h2>

        <motion.p
          className="enquiry-subheading"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Have a question? We’d love to hear from you! Please fill out the form below to send us your enquiry.
        </motion.p>
      </div>

      <div className="why-choose-us-wrapper-v9">
        <div className="why-choose-us-cards-v9">
          {features.map((feature, index) => (
            <div key={index} className="why-choose-us-card-v9">
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>

        <motion.div
          className="enquiry-wrapper"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <motion.form
            onSubmit={handleSubmit}
            className="enquiry-form"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleChange}
                pattern="^[0-9]{7,15}$"
                title="Please enter a valid phone number"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Your Message</label>
              <input
                id="message"
                type="text"
                name="message"
                placeholder="Enter your enquiry"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <motion.button
              type="submit"
              className="submit-btn"
              disabled={loading}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              {loading ? "Submitting..." : submitted ? "Thank you for your enquiry!" : "Submit Enquiry"}
            </motion.button>
          </motion.form>
        </motion.div>
      </div>
    </>
  );
};

export default Enquiry;
